import type { NearbyDatePriceType } from '../components/NearbyDatesPrices';

export const getMobileDatesPrices = (desktopDatesPricesArray: NearbyDatePriceType[]) => {
  const indexOfSelectedDatePrice = desktopDatesPricesArray.findIndex(
    (datePrice) => datePrice.isSelected === true,
  );

  if (indexOfSelectedDatePrice === 0 || indexOfSelectedDatePrice === 1) {
    return desktopDatesPricesArray.slice(0, 3);
  }

  return desktopDatesPricesArray.slice(1, -1);
};
